function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function renderedStr(nodeStr, skipSpace = false, isFirstNode) {
  return `${(isFirstNode || skipSpace) ? '' : ' '}${nodeStr}`
}

export default class TemplateUtils {
  static generateTemplate(formula, keyValueMap) {
    let templateStr = ''

    for (let node of formula) {
      // Separator nodes
      if (node.separator) {
        if (node.fixed || keyValueMap[node.toggler]) {
          templateStr = `${templateStr}${renderedStr(node.template, node.skipSpace, !templateStr)}`
        }

        continue
      }

      // Fixed nodes
      if (node.fixed) {
        if (node.template) templateStr = `${templateStr}${renderedStr(node.template, node.skipSpace, !templateStr)}`
        continue
      }

      // Variable nodes
      if (keyValueMap[node.key]) {
        templateStr = `${templateStr}${renderedStr(keyValueMap[node.key], node.skipSpace, !templateStr)}`
      }
    }

    return templateStr
  }

  static deduceTemplateVariables(formula, templateStr) {
    // 0. Early decision for empty template strings
    if (!templateStr) return null

    // 1. Exclude the UI-only nodes (those that doesn't affect generated template)
    const renderedNodes = formula.filter(node => {
      if (node.fixed && !node.template) return false
      return true
    })

    // 2. Generate regex groups
    // ex. %% product.name %%
    // ex. | .+
    // ex. .+
    const regexGroups = []
    const groupPrefixes = {}
    const userInputRegexStr = '.+'
    let nodeCursor = 0
    let groupCursor = 1
    while (nodeCursor < renderedNodes.length) {
      const node = renderedNodes[nodeCursor]

      if (node.fixed) {
        regexGroups.push({
          str: escapeRegExp(node.template),
        })

        nodeCursor++
        continue
      }

      if (node.separator) {
        const dependentNode = renderedNodes[nodeCursor+1]
        const str = `${escapeRegExp(node.template)} ${userInputRegexStr}`
        regexGroups.push({
          key: dependentNode.key,
          str,
          optional: true,
        })
        groupPrefixes[dependentNode.key] = node.template

        nodeCursor += 2
        continue
      }

      regexGroups.push({
        key: node.key,
        str: userInputRegexStr,
        optional: true,
      })
      nodeCursor++
    }

    // 3. Generate regex string from above groups (by concatenating)
    let regexStr = ''
    const keyGroupIndexMap = {}
    for (let i=0; i<regexGroups.length; i++) {
      const regexGroup = regexGroups[i]
      const isLast = i === regexGroups.length - 1

      if (!regexGroup.optional) {
        regexStr = `${regexStr}(${regexGroup.str}) ?`
        continue        
      }

      regexStr = `${regexStr}(${regexGroup.str}${isLast ? '' : ' '})?`
      keyGroupIndexMap[regexGroup.key] = i+1
    }

    // 4. Test the template string against the regex
    const regexObj = RegExp(`^${regexStr}$`)
    const matches = regexObj.exec(templateStr)

    // 5.1. Return null if no match (meaning that the template string isn't a recommended template)
    if (!matches) return null

    // 5.2. Deduce variable key-value pair from the matched group strings
    const nodeKeyValueMap = {}
    for (let nodeKey in keyGroupIndexMap) {
      const groupIndex = keyGroupIndexMap[nodeKey]
      let nodeValue = matches[groupIndex] || ''

      if (groupPrefixes[nodeKey]) {
        nodeValue = nodeValue.slice(groupPrefixes[nodeKey].length)
      }
      nodeValue = nodeValue.trim()
      nodeKeyValueMap[nodeKey] = nodeValue
    }
    return nodeKeyValueMap
  }

  static getCriticality(templateStr, formula, checklist) {
    // 2: critial, 1: warning, 0: all good
    if (!templateStr) return 2

    const keyValueMap = TemplateUtils.deduceTemplateVariables(formula, templateStr)
    if (!keyValueMap) return 0

    let criticality = 0
    for (let checkpoint of checklist) {
      if (!checkpoint.condition || checkpoint.optional) continue
      if (keyValueMap[checkpoint.condition]) continue

      if (checkpoint.critical) {
        criticality = 2
        break
      } else {
        criticality = 1
      }
    }

    return criticality
  }
}



// WEBPACK FOOTER //
// ./app/utils/TemplateUtils.js